import React, { FunctionComponent } from 'react';

import { rgba } from 'polished';
import styled from 'styled-components';

import { Option } from '@webapp/types/common/option';

import Flex from '@components/layout/flex';
import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';
import CrossIcon from '@components/basics/icons/cross';

import { motion } from 'framer-motion';
import { easeTransition } from '@components/framer';
import MotionOpacity from '@components/motion/motion-opacity';
interface FixedBottomMenuProps {
  className?: string;
  title: string;
  options: Option[];
  isShowing?: boolean;
  onClose: () => void;
  onSelect: (value: string) => void;
}

const FixedBottomMenu: FunctionComponent<FixedBottomMenuProps> = ({
  className,
  title,
  options,
  isShowing,
  onClose,
  onSelect,
}) => {
  const variants = {
    initial: {
      bottom: '-100%',
    },
    animate: {
      bottom: 0,
      transition: { ...easeTransition },
    },
  };
  return (
    <FixedBottomMenuWrapper className={className || ''}>
      <span className="backdrop" onClick={onClose} />
      <div className="bottom-menu">
        <motion.div
          className="bottom-menu-items"
          variants={variants}
          animate={isShowing ? 'animate' : 'initial'}
          initial="initial"
        >
          <Title alignItems="center" justifyContent="space-between" gap={20}>
            <Typography type="big-title" customFont="semi-bold">
              {title.length > 20 ? `${title.slice(0, 20)}...` : title}
            </Typography>
            <CrossIcon className="circle" darkGrey={true} onClick={onClose} />
          </Title>
          <Grid gap={10}>
            {options?.map((item) => (
              <Typography
                onClick={() => onSelect(item.value)}
                key={item.value}
                className={`${
                  item.value.includes('cancel') ||
                  item.value.includes('takedown') ||
                  item.value.includes('delete')
                    ? 'accent'
                    : null
                }`}
              >
                {item.label}
              </Typography>
            ))}
          </Grid>
        </motion.div>
      </div>
    </FixedBottomMenuWrapper>
  );
};

export default FixedBottomMenu;

const FixedBottomMenuWrapper = styled(MotionOpacity)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.zIndices.dialogs};

  .backdrop {
    background: ${({ theme }) => rgba(theme.colors.black, 0.3)};
    position: absolute;
    inset: 0;
  }

  .bottom-menu {
    height: 100%;
    z-index: ${({ theme }) => theme.zIndices.dialogs};

    .bottom-menu-items {
      position: absolute;
      width: 100%;
      padding: 2rem;
      background: ${({ theme }) => theme.colors.differentBackground};
      border-radius: 20px 20px 0px 0px;
      z-index: ${({ theme }) => theme.zIndices.dialogs};
      min-height: 200px;
      min-height: max-content;

      span {
        font-weight: 700;
      }

      .accent {
        padding-top: 20px;
        color: ${({ theme }) => theme.colors.accent};
      }
    }
  }
`;

const Title = styled(Flex)`
  width: 100%;
  padding-bottom: 20px;
`;
